var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirebase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 27,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    d: "M.01 21.784 3.333.519A.615.615 0 0 1 4.48.323l3.436 6.41 1.37-2.607a.614.614 0 0 1 1.088 0l9.274 17.658H.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    d: "m11.49 13.502-3.574-6.77L.01 21.785 11.49 13.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCA28",
    d: "m19.65 21.784-2.546-15.75a.615.615 0 0 0-1.038-.332L.01 21.784l8.883 4.981a1.841 1.841 0 0 0 1.794 0l8.963-4.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.2,
    d: "M17.104 6.033a.615.615 0 0 0-1.038-.331l-3.187 3.195-2.505-4.771a.614.614 0 0 0-1.088 0l-1.37 2.608L4.48.324a.613.613 0 0 0-1.147.195L.01 21.784H0l.01.012.087.044L16.06 5.858a.615.615 0 0 1 1.04.332l2.523 15.608.025-.014-2.544-15.75ZM.039 21.755 3.333.671a.61.61 0 0 1 .503-.51c.26-.044.519.082.644.315l3.436 6.41 1.37-2.608a.614.614 0 0 1 1.088 0l2.455 4.668L.04 21.756Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A52714",
    d: "M10.69 26.614a1.842 1.842 0 0 1-1.795 0L.033 21.648l-.02.136 8.882 4.98a1.841 1.841 0 0 0 1.794 0l8.961-4.98-.023-.142-8.938 4.972Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M17.08 6.035a.608.608 0 0 0-1.034-.332L12.868 8.9l-2.497-4.77a.611.611 0 0 0-1.084 0L7.923 6.739 4.499.329a.61.61 0 0 0-1.143.196L.046 21.78l8.851 4.979a1.83 1.83 0 0 0 1.788 0l8.928-4.98-2.534-15.744Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -0.639,
    x2: 23.782,
    y1: 4.603,
    y2: 17.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fff",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#fff",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h19.65v27H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/Firebase.03b47a2b46c0d13782945a9600bf14bc.svg";
export { ForwardRef as ReactComponent };